module.exports = __webpack_public_path__ + "img/pc_banner_terms.9ceafb86.png";